const merge = require('lodash.merge');
const defaultConfig = require('./default.json');

let config = defaultConfig;

if(window.__config) {
    merge(config, window.__config);
}

module.exports = config;



// WEBPACK FOOTER //
// ./configs/client-config-loader.js